// extracted by mini-css-extract-plugin
export var searchHeader = "_97-0";
export var searchHeaderDark = "_97-1";